import { useGetKpiBenchmarksQuery } from '../gql/generated/graphql';
import { BenchmarkData } from '../pages/DFMPage/components/KPICard/KPICard';

/**
 * Hook to fetch KPI benchmarks from the GraphQL backend
 * Maps the backend response to the frontend BenchmarkData format
 */
export const useKPIBenchmarks = () => {
  const { data, loading, error } = useGetKpiBenchmarksQuery();

  /**
   * Converts GraphQL benchmark data to frontend BenchmarkData format
   */
  const convertToBenchmarkData = (
    benchmarks: Array<{
      kpiName?: string | null;
      percentile25?: number | null;
      percentile50?: number | null;
      percentile75?: number | null;
      nonNullCount?: number | null;
    } | null>
  ): Record<string, BenchmarkData> => {
    const result: Record<string, BenchmarkData> = {};

    benchmarks.forEach(benchmark => {
      if (benchmark?.kpiName) {
        let camelCaseKey: string;

        // Special handling for specific KPIs with naming mismatches
        if (benchmark.kpiName === 'top_3_customer_share') {
          camelCaseKey = 'top3CustomerShare';
        } else if (benchmark.kpiName === 'net_new_customer_sales_growth_rate') {
          camelCaseKey = 'netNewCustomerSalesGrowth';
        } else {
          camelCaseKey = benchmark.kpiName.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
        }

        result[camelCaseKey] = {
          median: benchmark.percentile50 || 0,
          p25: benchmark.percentile25 || 0,
          p75: benchmark.percentile75 || 0,
          p90: benchmark.percentile75 || 0, // Using p75 as fallback for p90
          industry: 'Software',
          nonNullCount: benchmark.nonNullCount || undefined,
        };
      }
    });

    return result;
  };

  const benchmarkData = data?.kpiBenchmarks ? convertToBenchmarkData(data.kpiBenchmarks) : undefined;

  return {
    benchmarks: benchmarkData,
    loading,
    error,
  };
};
